import { render, staticRenderFns } from "./DirectSignUpVerificationForm.vue?vue&type=template&id=5eb576cb&scoped=true"
import script from "./DirectSignUpVerificationForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./DirectSignUpVerificationForm.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./DirectSignUpVerificationForm.vue?vue&type=style&index=0&id=5eb576cb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eb576cb",
  null
  
)

export default component.exports